<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="版本">
              <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.mpsVersion"
                selectType="select"
                requestApi="/scp/scpMpsPlans/listMpsPlanVersion"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <global-select
                :max-tag-count="2"
                :max-tag-text-length="4"
                show-search
                :value.sync="queryParams.supplierId"
                :setParams="{scpSupplierCategory:'内部'}"
                searchParam="supplierName"
                selectType="selectSearch"
                requestApi="/scp/scpSopMpsSupplierCapacityLoad/supplierPullDown"
                :dropdown-match-select-width="false"
                :selectItem="{ value: 'realValue', label: 'selectedValue' }"
              />
              <!-- <global-select
                @change="handleVersionChange"
                :value.sync="queryParams.supplierId"
                selectType="select"
                requestApi="/mdm/mdmOrgSupplier/supplierAbbreviationList"
                :selectItem="{ value: 'label', label: 'label' }"
              />-->
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="工艺大类">
              <global-select
                :value.sync="queryParams.productBroadCategoryList"
                selectType="selectMultipleSearch"
                requestApi="/system/lookup/data/likeList"
                :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                :setParams="{ lookupType: 'SCP_PRODUCT_BROAD_CATEGORY' }"
                searchParam="lookupValue"
                :dropdown-match-select-width="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button :loading="isCalculating" @click="handlCalculate" type="primary">刷新</a-button>
      <a-button @click="handleExport" type="primary" v-hasPermi="['scp:scpSopMpsSupplierCapacityBalance:export']">导出</a-button>

    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <a-spin :spinning="isLoading">
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :selectedRows.sync="selectedRows"
            :multi-select="true"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true, x: 1300 }"
            @selectedRowChange="selectedRowChange"
          >
            <template slot="fixedEllipsis" slot-scope="{ text, column }">
              <a-tooltip placement="top">
                <template slot="title">
                  <span>{{ text }}</span>
                </template>
                <span :style="{ width: `${column.width - 32}px` }" class="ellipsis">{{ text }}</span>
              </a-tooltip>
            </template>
            <template slot="inputNumber" slot-scope="{ record, column }">
              <!-- <span v-if="!isEdit || （currentId !== record.id">{{ record[column.dataIndex]?(record[column.dataIndex] + (filteredChildrenIndexKey.includes(column.dataIndex)?'%':'')):'' }}</span> -->
              <span v-if="!isEdit || currentId !== record.id">{{ record[column.dataIndex] }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.id && column.myTitle!=='汇总'"
                v-model="record[column.dataIndex]"
                size="small"
              />
            </template>
            <!-- 操作 -->
            <span slot="operation" slot-scope="{ record }">
              <a v-if="(!isEdit || currentId !== record.id) && record.project.includes('人工调整后产能负荷') " @click="handleEdit(record)" v-hasPermi="['scp:scpSopMpsSupplierCapacityBalance:edit']">编辑</a>
              <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
              <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
            </span>
          </ls-api-table>
        </a-spin>
      </div>
    </template>

  </ls-table-layout>
</template>
  <script>
  import {
    apiDelScpSopFcInitialDeliveryRatio
  } from '@/api/scp/shipmentForecast/shipmentForecastSetting'
  import { generateLsTableResData } from '@/utils/util.js'
  import { apiScpSopMpsSupplierCapacityBalanceList, apiScpCalculateCapacityBalance, apiUpdateScpSopMpsSupplierCapacityBalance } from '@/api/mps/basic-data/mps-capacity-balance.js'

  export default {
    // eslint-disable-next-line
    name: 'Mps-capacity-balance',
    components: {
      },
    props: {
      id: {
        type: String,
        default: '1' // 设置默认值为'Hello from child'
      }
    },
    data () {
      return {
        isCalculating: false,
        listSideOpinions: [],
        productBroadCategoryOpinions: [],
        isLoading: false,
        url: '/scp/scpSopFcInitialDeliveryRatio/import',
        isEdit: false,
        tableList: [],
        // 表格配置
        tableProps: {
          requestApi: generateLsTableResData(apiScpSopMpsSupplierCapacityBalanceList, true),
          pageCurrent: true
        },
        columns: [],
        columnsServe: [],
        // 表格字段
        columnsNative: [
          {
            title: '供应商',
            dataIndex: 'supplierAbbreviation',
            width: 120,
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'fixedEllipsis' },
            fixed: 'left'
          },
          {
            title: '项目',
            dataIndex: 'project',
            width: 180,
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'fixedEllipsis' },
            fixed: 'left'
          },
          {
            title: '工艺大类',
            dataIndex: 'productBroadCategory',
            width: 120,
            ellipsis: true,
            align: 'center',
            scopedSlots: { customRender: 'fixedEllipsis' },
            fixed: 'left'
          },
          {
            title: '操作',
            fixed: 'right',
            dataIndex: 'operation',
            scopedSlots: { customRender: 'operation' },
            width: 120,
            ellipsis: true,
            align: 'center'
          }
        ],
        queryParams: {
          supplierId: undefined,
          mpsId: undefined,
          productBroadCategory: undefined,
          supplierAbbreviation: undefined,
          scpSupplierCategory: undefined
        },
        // 表格多选
        selectedRowKeys: [],
        selectedRows: []
      }
    },
    methods: {
      handleVersionChange (val, list) {
        if (val) {
          const filteredObject = list.filter(obj => obj.realValue === val);
          this.queryParams.supplierId = filteredObject[0].selectedValue;
        }
      },
      selectedRowChange (selectedRowKeys, selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
      },
          /** 重置按钮操作 */
      resetQuery () {
        this.queryParams = {
          supplierId: undefined,
          mpsId: undefined,
          productBroadCategory: undefined,
          supplierAbbreviation: undefined,
          scpSupplierCategory: undefined
        }
        this.onSearch()
      },
          /** 导出按钮操作 */
     handleExport () {
        this.download('scp/scpSopMpsSupplierCapacityBalance/export', {
          ...this.queryParams
        }, `供应商产能均衡导出报表_${new Date().getTime()}.xlsx`)
      },
     // 新增/修改框事件
       handleOk () {
          // this.onSearch()
        },
        handlCalculate () {
        if (!this.queryParams.mpsVersion) {
            this.$message.error('请选择版本')
            return
        }
        const self = this
        this.$confirm({
          title: '警告',
          content: `你确定要重新计算数据么?`,
          okText: '计算',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            self.isCalculating = true
            apiScpCalculateCapacityBalance({ mpsVersion: self.queryParams.mpsVersion }).then((response) => {
                self.isCalculating = false
              if (response.code === 200) {
                self.$message.success('已开始计算')
                self.onSearch()
              } else {
                self.$message.error(response.msg)
              }
            }).catch(e => { self.isCalculating = false })
          }
        })
      },
      handleDelete (tableList, record) {
        const self = this
        this.$confirm({
          title: '警告',
          content: `真的要删除该项的数据项吗?`,
          okText: '删除',
          okType: 'danger',
          cancelText: '取消',
          onOk () {
            const ids = []
            self.columnsServe.forEach((column) => {
              console.log(column.indexKey)
              const id = record[column.indexKey].id
              ids.push(id)
            })
            apiDelScpSopFcInitialDeliveryRatio(ids).then((response) => {
              if (response.code === 200) {
                self.$message.success('删除成功')
                self.onSearch()
              } else {
                self.$message.error(response.msg)
              }
            })
          }
        })
      },
      // 编辑-保存
      handleSave (record) {
        const recordCopy = JSON.parse(JSON.stringify(record))
        apiUpdateScpSopMpsSupplierCapacityBalance(recordCopy).then((response) => {
          if (response.code === 200) {
            this.$message.success('更新成功')
            this.onSearch()
          } else {
            this.$message.error(response.msg)
          }
        })
      },
      // 取消
      handleCancel (record) {
        this.isEdit = false
        this.onSearch()
      },
      getLookupList (type, arr) {
          const lookupQueryParams = {
          lookupType: type,
          current: 1,
          pageSize: 100
          }
          this.getLookupListData(lookupQueryParams).then().then(response => {
          this[arr] = response.rows
          if (type === 'MDM_ORG_SUPPLIER_CLASS') {
              const filteredArray = response.rows.filter(function (obj) {
                  return obj.attribute2 === "Y";
                  });
                  this[arr] = filteredArray
          }
          })
      },
      getTableInfo (id) {
        if (this.isLoading) {
          return
        }
        this.isLoading = true
        apiScpSopMpsSupplierCapacityBalanceList(id).then((response) => {
          this.isLoading = false
          if (response.code === 200) {
            this.tableList = response.rows
            this.tableList.forEach((obj, index) => {
              obj.id = index + 1 // 生成唯一的ID，可以使用索引值加上 1
            })
            this.$refs.dataTable.myDataSource = this.tableList
            const titles = response.title
            this.columnsServe = response.title
            // 生成新的对象数组，并为每个对象添加name属
            const newArray = titles.map((title) => {
                  return {
                            title: title.indexName,
                            dataIndex: title.indexKey,
                            scopedSlots: { customRender: 'inputNumber' },
                            width: 120,
                            myTitle: title.indexName,
                            align: 'center'
                          }
            })
            const dynamicColumn = this.setNewColumn('productBroadCategory', this.columnsNative, newArray)
            this.columns = dynamicColumn
            this.$refs.dataTable.myPagination.total = response.total
            this.$refs.dataTable.pageTotal = this.$refs.dataTable.getPageTotal(response.total, this.$refs.dataTable.myPagination.pageSize)
          } else {
            this.tableList = []
            this.$refs.dataTable.myDataSource = this.tableList
            this.$message.error(response.msg)
          }
        }).catch((error) => {
          this.isLoading = false
          // 处理 API 调用失败的情况
          console.error('API 调用失败: ', error);
        })
      },
      // 表单搜索
      onSearch () {
        this.isEdit = false
         this.$refs.dataTable.searchParams = this.queryParams;
        // this.$refs.dataTable.getData();
        this.$refs.dataTable.myPagination.current = 1
        this.getTableInfo({ ...this.queryParams, pageSize: this.$refs.dataTable.myPagination.pageSize, pageNum: 1 })
      },
      /**
       * 在table 某个列的字段后增加列
       * key：列的字段名称
       * columnList 列表的列
       * insertColumnList 插入的新列
       *  */
      setNewColumn (key, columnList, insertColumnList) {
        const newArray = [...columnList] // 创建新的数组，保持原始数据的不变
        const index = newArray.findIndex((item) => item.dataIndex === key) // 找到具有indexKey值为'kk'的对象的索引位置
        if (index !== -1) {
          newArray.splice(index + 1, 0, ...insertColumnList) // 在索引位置后面插入新数组
        }
        return newArray
      },
      // 编辑
      handleEdit (record, index) {
        if (this.currentId && record.id !== this.currentId && this.isEdit) {
          this.$message.warning('请保存上次编辑的数据')
          return
        }
        this.isEdit = true
        this.currentId = record.id
      }
    },
    created () {
      // this.getTableInfo()
      this.queryParams.mpsVersion = this.$route.query.id
        this.getLookupList('SCP_PRODUCT_BROAD_CATEGORY', 'productBroadCategoryOpinions')
         this.getLookupList('MDM_ORG_SUPPLIER_CLASS', 'listSideOpinions')
    },
    mounted () {
      this.columns = this.columnsNative
      this.onSearch()
    }
  }
  </script>

  <style scoped lang="less">
  .ellipsis{
    display:block;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .content {
    display: flex;
    flex-direction: column;
  }
  .table {
    flex: 1;
  }
  </style>
